import React, { useEffect, useState, useContext } from "react";
import { Container } from "react-bootstrap";
import axios from "axios";
import AppContext from "../../../context/AppContext";
import "../../../assets/css/customer/dashboard/Support.css";
import { useNavigate } from "react-router-dom";
import { checkLoggedInCustomer } from "../../../helper/CustomHelper";

const CustomerSupport = () => {
  const navigate = useNavigate();
  const { baseUrl } = useContext(AppContext);
  const [message, setMessage] = useState("");
  const [messages, setMessages] = useState([]);

  const sendMessage = () => {
    if (message.trim() === "") return;
    const formData = new FormData();
    formData.append("customer_id", JSON.parse(localStorage.getItem("customer")).id);
    formData.append("subject", "Support");
    formData.append("message", message);
    axios
      .post(`${baseUrl}/customer/support/sendMessage`, formData)
      .then((response) => {
        console.log("SEND RESPONSE:", response.data);
        viewMessages();
        setMessage("");
      })
      .catch((error) => console.log("ERROR:", error.response));
  };

  const viewMessages = () => {
    const formData = new FormData();
    formData.append("escustomer_id", JSON.parse(localStorage.getItem("customer")).id);
    axios
      .post(`${baseUrl}/customer/support/viewMessages`, formData)
      .then((response) => {
        // Sort ascending — purana upar, naya neeche
        const sorted = [...response.data].sort(
          (a, b) => new Date(a.created_at) - new Date(b.created_at)
        );
        setMessages(sorted);
      })
      .catch((error) => console.log(error));
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      sendMessage();
    }
  };

  useEffect(() => {
    checkLoggedInCustomer(navigate);
    viewMessages();
  }, []);

  return (
    <Container fluid>
      <div className="sgc-support-page">
        <h1 className="sgc-support-title">Support</h1>

        {/* ===== CHAT AREA ===== */}
        <div className="sgc-support-chat-wrapper">

          {messages.length === 0 ? (
            /* Default admin welcome message */
            <div className="sgc-support-message-row sgc-support-admin-row">
              <div className="sgc-support-admin-message">
                <div className="sgc-support-admin-title">Admin</div>
                <p className="sgc-support-admin-text">
                  Hi! How can the clinic team help you today?
                </p>
              </div>
            </div>
          ) : (
            messages.map((msg) => {
              const isAdmin = msg.sender === "admin";
              return (
                <div
                  key={msg.id}
                  className={`sgc-support-message-row ${
                    isAdmin
                      ? "sgc-support-admin-row"    // left — white
                      : "sgc-support-customer-row" // right — pink
                  }`}
                >
                  {isAdmin ? (
                    /* Admin message — left, white */
                    <div className="sgc-support-admin-message">
                      <div className="sgc-support-admin-title">Admin</div>
                      <p className="sgc-support-admin-text">{msg.message}</p>
                    </div>
                  ) : (
                    /* Customer message — right, pink */
                    <div className="sgc-support-customer-message">
                      {msg.message}
                    </div>
                  )}
                </div>
              );
            })
          )}

        </div>

        {/* ===== INPUT AREA ===== */}
        <div className="sgc-support-input-wrapper">
          <input
            type="text"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder="Type your message..."
            className="sgc-support-input"
          />
          <button onClick={sendMessage} className="sgc-support-send-btn">
            ➤
          </button>
        </div>

      </div>
    </Container>
  );
};

export default CustomerSupport;